export const actions = {
  SUBMIT_SURVEY: "submitSurvey",
};

export const mutations = {
  SET_SURVEY_DATA: "SET_SURVEY_DATA",
  SET_FURTHER_SURVEY_DATA: "SET_FURTHER_SURVEY_DATA",
  RESET_SURVEY_DATA: "RESET_SURVEY_DATA",
}
